export default {
  common: {
    confirm: '确认',
    confirmed: '已确认',
    cancel: '取消',
    select: '请选择',
    search: '搜索',
    notice: '提示',
    confirmRole: '确认角色信息',
    announce: '公告'
  },
  pay: {
    title: {
      SelectCharacter: '选择角色',
      SelectBundle: '商品选购',
      game: '游戏',
      gamePlaceholder: '请选择游戏',
      server: '区服',
      serverPlaceHolder: '请选择区服',
      role: '角色',
      rolePlaceHolder: '请选择角色'
    },
    instructions: {
      title: '充值说明',
      subtext: '服务说明',
      paragraph1: '1、为保障您的权益，购买商品前，请先仔细阅读商品详细说明。',
      paragraph2:
        '2、本服务仅面向已在游戏内完成创角的用户。未完成创角的用户将无法在本页面检测到对应区服、角色信息，请确认您的创角信息后再进行充值。',
      paragraph3: '3、重要提示：输入区服、角色ID后，请仔细核对您的账户角色信息，确认无误后再进行下一步操作!',
      paragraph4:
        '4、付款成功后，通过本页面购买的商品将通过游戏内邮件发放到您的游戏账户。若您在充值成功30分钟后还没有收到商品，可通过游戏内悬浮窗联系对应客服进行反馈，我们将及时为您解决问题。',
      paragraph5:
        '5、充值到账时间可能会因网络传输延迟而有所变化，最终到账状态请以游戏内实际显示为准。如遇疑问，请随时联系客服人员为您解答。"'
    },
    Region: '大区',
    Server: '服务器',
    ServerPlaceholder: '区服（点击搜索）',
    CharacterID: '角色ID',
    CharacterName: '角色名',
    RoleName: '角色名',
    bundelDetails: '商品详情',
    protocal: {
      services: '用户协议',
      policy: '隐私政策',
      address: '5, 8/F, Mega Cube, 8 Wang Kwong Road, Kowloon Bay, Kowloon, Hong Kong',
      ysAddress: 'ward 7, North Jhagrakhand , maharana pratap ward, manendragarh, koriya, chhattisgarh Manendragarh - 497446',
    },
    dialogMessage: {
      reenter: '请重新输入您的角色信息',
      selectServer: '请先绑定角色',
      selectRoleId: '请先绑定角色',
      fillCharacterID: '请填写您的角色ID',
      confirmCharacter: '请确认您的角色信息'
    },
    footer: {
      safe: {
        title: '安全',
        subTitle: '官方支付中心'
      },
      convenient: {
        title: '便捷',
        subTitle: '一键加购，快捷支付'
      },
      economical: {
        title: '实惠',
        subTitle: '丰富的返利'
      },
      efficient: {
        title: '高效',
        subTitle: '急速到账，无延迟'
      }
    },
    announce: {
      type: '活动'
    }
  },
  paySubmit: {
    paymenMethod: '支付方式',
    prodDetails: '商品详情',
    discount: '折扣',
    discountCode: '折扣码',
    submit: '提交',
    total: '总计',
    fillDiscountCode: '请输入您的折扣码',
    protocal: '已阅读运营条例，且确认商品和道具价格',
    agree: '请同意协议',
    currentRegion: '当前地区',
    paymentMethods: '支付方式',
    items: '商品',
  },
  payFail: {
    title: '支付失败，请重试',
    desc: '若仍无法完成支付，请更换支付方式或联系客服获取帮助。',
    loading: '订单状态查询中...',
    apiError: '接口异常，请稍后重试',
  }
};
